module.exports = __webpack_public_path__ + "img/base_restauration_fait_maison.8f67e7d0.svg";